const settings = {
    debounceTime: 1000,
    notificationsPopoverLength: 5
}

module.exports = { settings }